import { render, staticRenderFns } from "./allCourse.vue?vue&type=template&id=0d53ca79&scoped=true&"
import script from "./allCourse.vue?vue&type=script&lang=js&"
export * from "./allCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d53ca79",
  null
  
)

export default component.exports